import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_102: FaireProductEntity = {
  token: "starter_collection_102",
  type: "product",
  name: "Niko Margarita Glass",
  brandName: "Be Home",
  imageUrl:
    '"https://cdn.faire.com/fastly/2ea714f4e3a8677ff728702d95b8afd1d23075d49df10984d818d337f9b25ceb.jpeg?bg-color=FFFFFF&dpr=2&fit=crop&format=jpg&height=720&precrop=1911',
  priceDollars: 18,
  msrpDollars: 36,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
